import { render, staticRenderFns } from "./SyntheticTransactionReport.vue?vue&type=template&id=223b8f61"
import script from "./SyntheticTransactionReport.vue?vue&type=script&lang=js"
export * from "./SyntheticTransactionReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports